// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RbWS4","footer":"styles_footer__oRfmX"};